import { create } from 'zustand';
import { adminSyncDiffApi } from '@api/api-config.ts';
import { SyncDiffResult } from './types.ts';

interface AdminSyncDiffStoreState {
  loading: boolean;
  error: string | null;
  data: SyncDiffResult | null;
  loadSyncDiff: (orgSourceId: number, sourceType: string) => Promise<void>;
  exportMissing: (orgSourceId: number, sourceType: string) => Promise<void>;
  exporting: boolean;
  reset: () => void;
}

export const useAdminSyncDiffStore = create<AdminSyncDiffStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  exporting: false,

  loadSyncDiff: async (orgSourceId: number, sourceType: string) => {
    try {
      set({ loading: true, error: null });
      const response = await adminSyncDiffApi.getSyncDiff({ orgSourceId, sourceType });
      // Generovaný typ je strukturálně shodný; přetypujeme na lokální view-typ kvůli stabilnímu enumu.
      set({ loading: false, error: null, data: response.data as unknown as SyncDiffResult });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba pri nacitani sync diffu',
      });
    }
  },

  exportMissing: async (orgSourceId: number, sourceType: string) => {
    set({ exporting: true, error: null });
    try {
      const response = await adminSyncDiffApi.exportSyncDiffMissing({ orgSourceId, sourceType }, { responseType: 'blob' });
      const url = window.URL.createObjectURL(response.data as unknown as Blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `chybi-v-db-${orgSourceId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      set({ exporting: false });
    } catch (error) {
      set({
        exporting: false,
        error: error instanceof Error ? error.message : 'Export se nepodarilo stahnout',
      });
    }
  },

  reset: () => set({ loading: false, error: null, data: null, exporting: false }),
}));
